export default {
  title: "Índice de Riesgo",
  items: {
    noData: "Sin datos",
    invalidArea: "Área no válida"
  },
  footer: "Escala: 1-10 (valores bajos a altos)"
}
